import React from "react";
import { styled } from "@mui/material";
import { theme } from "styles/themes";

const HandOffNotesDisabledBanner = () => {
  return (
    <DisabledBanner>
      <IconContainer>i</IconContainer>
      <div>
        Design has already started on this project. To share additional information or make a change request, please
        submit a ticket.
      </div>
    </DisabledBanner>
  );
};

export default HandOffNotesDisabledBanner;

export const DisabledBanner = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  marginBottom: "24px",
  background: theme.colors["darkest-blue"],
  padding: "14px 22px",
  borderRadius: "12px",
  color: "white",
  fontWeight: 600,
  fontFamily: "Poppins",
  lineHeight: "18px",
  gap: "16px",
}));

export const IconContainer = styled("div")(() => ({
  height: "24px",
  minWidth: "24px",
  width: "24px",
  border: `1px solid ${theme.colors.white}`,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
